import { render, staticRenderFns } from "./BookingComments.vue?vue&type=template&id=f5a77d18&"
import script from "./BookingComments.vue?vue&type=script&lang=js&"
export * from "./BookingComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports